export const common = {
  // Navigation
  home: 'Accueil',
  about: 'À propos',
  services: 'Services',
  projects: 'Réalisations',
  contact: 'Contact',
  getQuote: 'Demander un devis',
  
  // Hero Section
  heroTitle: 'Donnez vie à votre projet de rénovation à Bruxelles',
  heroSubtitle: 'Une entreprise belge fiable, transparente et expérimentée pour vos travaux de rénovation et de construction',
  heroValueLine: 'Devis gratuit • Réponse sous 24h • Suivi personnalisé',
  heroCTA: 'Demander un devis gratuit',
  
  // Trust Highlights
  trustTitle: 'Pourquoi choisir Ktran ?',
  trustExperience: 'Plus de 15 ans d\'expérience terrain',
  trustLocal: 'Entreprise belge basée à Bruxelles',
  trustTransparent: 'Devis clair et suivi rigoureux des travaux',
  
  // Services
  servicesTitle: 'Nos Services',
  servicesSubtitle: 'Des solutions complètes pour tous vos besoins en rénovation et construction',
  
  masonryTitle: 'Maçonnerie',
  masonryDesc: 'Des travaux de maçonnerie solides et durables pour sécuriser et valoriser votre bien immobilier',
  
  bathroomTitle: 'Salle de bain & Cuisine',
  bathroomDesc: 'Des espaces modernes, fonctionnels et esthétiques, conçus pour votre confort quotidien',
  
  paintingTitle: 'Peinture & Finitions',
  paintingDesc: 'Des finitions soignées qui subliment vos espaces et assurent un rendu impeccable dans le temps',
  
  partitionTitle: 'Cloisons & Isolation',
  partitionDesc: 'Une isolation performante pour améliorer votre confort thermique et réduire vos dépenses énergétiques',
  
  carpentryTitle: 'Menuiserie',
  carpentryDesc: 'Installation et rénovation de portes, fenêtres et aménagements sur mesure avec un savoir-faire artisanal',
  
  electricalTitle: 'Électricité',
  electricalDesc: 'Installations électriques conformes aux normes belges pour votre sécurité et votre tranquillité',
  
  // Process Steps
  processTitle: 'Notre Processus',
  processSubtitle: 'Une démarche simple et transparente pour garantir la réussite de votre projet',
  
  step1Title: 'Analyse de votre projet et de vos besoins',
  step1Desc: 'Nous écoutons vos besoins et visitons les lieux pour comprendre pleinement votre projet',
  
  step2Title: 'Étude détaillée et devis transparent',
  step2Desc: 'Nous vous proposons un devis détaillé et clair, sans frais cachés',
  
  step3Title: 'Réalisation des travaux avec suivi personnalisé',
  step3Desc: 'Nous réalisons les travaux avec professionnalisme, suivi régulier et communication constante',
  
  // Projects
  projectsTitle: 'Nos Réalisations',
  projectsSubtitle: 'Découvrez quelques-uns de nos projets réalisés à Bruxelles et ses environs',
  projectNote: 'Un projet réalisé avec soin, dans le respect des délais et du budget',
  viewAllProjects: 'Voir toutes les réalisations',
  
  // Value Section
  valueTitle: 'Notre Engagement envers Vous',
  valueSubtitle: 'Des valeurs qui guident chacune de nos interventions',
  
  qualityTitle: 'Qualité du Travail',
  qualityDesc: 'Nous utilisons des matériaux de qualité supérieure et appliquons les meilleures techniques pour garantir des résultats durables et esthétiques',
  
  timeTitle: 'Respect des Délais',
  timeDesc: 'Chaque projet est planifié avec précision. Nous nous engageons à respecter les délais convenus pour votre tranquillité d\'esprit',
  
  cleanTitle: 'Chantier Propre',
  cleanDesc: 'Nous maintenons un chantier organisé et propre tout au long des travaux, avec un nettoyage complet en fin de chaque journée',
  
  communicationTitle: 'Communication Transparente',
  communicationDesc: 'Nous vous tenons informé à chaque étape du projet. Nous restons disponibles pour répondre à vos questions et ajuster selon vos besoins',
  
  registeredCompanyDesc: 'Une société légalement établie et assurée pour votre sécurité',
  belgianStandardsDesc: 'Tous nos travaux respectent strictement la réglementation en vigueur',
  qualityCommitmentDesc: 'Votre satisfaction est notre priorité, du devis à la livraison finale',
  
  // Final CTA
  finalCTATitle: 'Prêt à concrétiser votre projet ?',
  finalCTAText: 'Contactez-nous dès aujourd\'hui pour un devis gratuit et personnalisé. Nous vous accompagnons de la première idée jusqu\'à la livraison finale',
  finalCTAButton: 'Demander un devis gratuit',
  
  // Footer
  footerAbout: 'Expert en rénovation à Bruxelles. Nous transformons vos espaces avec qualité et professionnalisme',
  footerQuickLinks: 'Liens rapides',
  footerLegal: 'Mentions légales',
  footerContact: 'Contact',
  footerRights: 'Tous droits réservés',
  footerVAT: 'N° TVA',
  poweredBy: 'Propulsé par BeneluxWeb',
  
  // Common Actions
  learnMore: 'En savoir plus',
  contactUs: 'Nous contacter',
  callUs: 'Appelez-nous',
  emailUs: 'Écrivez-nous',
  
  // Trust Signals
  registeredCompany: 'Entreprise enregistrée en Belgique',
  belgianStandards: 'Respect des normes belges',
  qualityCommitment: 'Engagement qualité et satisfaction client',
  
  // Stats
  projectsCompleted: 'Projets réalisés',
  yearsExperience: 'Ans d\'expérience',
  satisfiedClients: 'Clients satisfaits',
  projectsDelivered: 'Projets livrés',
  
  // Time
  freeQuote: 'Devis gratuit',
  response24h: 'Réponse sous 24h',
  personalizedFollowup: 'Suivi personnalisé'
};